export default __webpack_public_path__ + "static/media/affisch_2_a2_ara_home_printer.5587ab52.png";